import { PropsWithChildren, forwardRef } from 'react';

import { IconProps } from './interface';

const defaultProps = {
  size: '1em',
};

const spinStyle = {
  animation: 'spin 1s linear infinite',
};

const getSize = (size: IconProps['size']) => {
  if (Array.isArray(size) && size.length === 2) {
    return size as string[];
  }
  const width = (size as string) || '1em';
  const height = (size as string) || '1em';
  return [width, height];
};

export const Icon = forwardRef<SVGSVGElement, PropsWithChildren<IconProps>>((baseProps, ref) => {
  const props = { ...defaultProps, ...baseProps };
  const { spin, className, size, style, children, ...rest } = props;

  const [width, height] = getSize(size);

  return (
    <svg
      ref={ref}
      className={className}
      width={width}
      height={height}
      style={{ display: 'inline-block', ...(spin ? spinStyle : {}), ...style }}
      focusable="false"
      fill="currentColor"
      {...rest}
    >
      {children}
    </svg>
  );
});

Icon.displayName = 'Icon';
